import { MainColor } from '../../palette/colors';

export const getExternalReception = () => {
  return {
    iconColors: {
      green: 'green50' satisfies MainColor as MainColor,
      orange: 'orange50' satisfies MainColor as MainColor,
    },
  };
};

export type ExternalReception = ReturnType<typeof getExternalReception>;
